import request from '@/utils/request'

/**
 * 根据字典类型获取字典数据
 * @param {string} dictType - 字典类型编码
 * @returns {Promise}
 */
export function getDictDataByType(dictType) {
  return request({
    url: `/admin/dict/data/type/${dictType}`,
    method: 'get'
  })
}
